
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useCallback } from 'react';
import Modal from './Modal';
import { ElementStore, ReactFormGenerator } from './react-form-builder-innovate/src/index';

export const FormbuilderPre = (props) => {
  const { classes, mode, data } = props;
  const [previewVisible, setPreviewVisible] = useState(false);

//   const showPreview = useCallback(() => setPreviewVisible(true), []);
  const showPreview = () => {

    const state = ElementStore.getState?.() || {};
  const live = Array.isArray(state.data) ? state.data : [];
  console.log("live==> prevbuilder", live)
  // setBuilderFormData(live); // in parent, if needed
    setPreviewVisible(true) 
  }
  const closePreview = useCallback(() => setPreviewVisible(false), []);

  const handleSubmit = useCallback((payload) => {
    // eslint-disable-next-line no-console
    console.log('onSubmit', payload);
    // post filled answers if you ever need that
  }, []);

  return (
    <>
      {/* <button type="button" className={classes.viewlink} onClick={showPreview}>
        Preview Form
      </button> */}

<button type="button" className={classes.viewlink}
        onClick={showPreview} disabled={!Array.isArray(data) || data.length === 0}>
  Preview Form
</button>


      {previewVisible && (
        <Modal hasCloseBtn isOpen={previewVisible} onClose={closePreview}>
          {/* Always render the latest schema coming from the parent */}
          <ReactFormGenerator
            data={Array.isArray(data) ? data : []}
            hide_actions
            onSubmit={handleSubmit}
          />
        </Modal>
      )}
    </>
  );
};

